import { Budget } from "../../interfaces"

export * from "./getStartingMetrics"
export const company: Budget[] = require("./company.json")

